import { KeyValue } from '@angular/common';

// utility method to preserve order or object properties when iterated over via ngFor and KeyValue
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const keepOriginalOrder = <T>(a: KeyValue<string, T[]>, b: KeyValue<string, T[]>): number => 0;
